<template>
  <div >
    <SkeletonLoader v-if="isLoading" :count="10"
    >
      <template #default>
        <!-- Линии для контента -->
        <div class="skeleton-lines" v-for="num in 15" :key="num">
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
        </div>
      </template>
    </SkeletonLoader>
    <template v-for="item in levelContent">
      <DescView v-if="item.type === 'desc' && item.text.length > 5" :desc="item" />
      <EditorExView v-else-if="item.type === 'translate'" @ex-completed="onExCompleted" @start-again="onStartAgain"
      :exercise-id="item.id" :exercise-index="item.idx" :exercise-item="item.ex" :key="item.exKey" :default-open="item.open" />
    </template>

    <div class="level-end-btns">
      <a v-if="prevLevelLink" :href="prevLevelLink" :class='["button next-btn btns" ]'>Назад</a>
      <a v-if="showNextBtn" :href="nextLevelLink" :class='["button next-btn btns", !prevLevelLink && "next-btn-alone" ]'>Продолжить</a>
    </div>
    <div v-if="showRegBtn" class="level-end-btns">
      <a :href="nextLevelLink" @click.prevent="emitShowModalReg" :class='["button next-btn btns" ]'>Для продолжения необходимо войти или зарегистрироваться</a>
    </div>
  </div>

  <Teleport to="body">
    <modal id="modal-word" :show="showModalWord" :show-ok-btn="false" @close="closeWord()">
      <template #header>
        <h3>Словарь</h3>
      </template>
      <template #body>
        <div class="modal-word-def-wrap">
          <div class="modal-word-def-wrap-inner" v-html="modalWordContent"></div>
          <a href="#" :class='["btns"]' @click.prevent="closeWord">Закрыть</a>
        </div>
      </template>
    </modal>
  </Teleport>
</template>

<script>
// @ is an alias to /src
import EditorExView from "@/components/level/EditorExView.vue";
import DescView from "@/components/level/DescView.vue";
import subLevelClient from "@/client/subLevel.js";
import exerciseClient from "@/client/exercise.js";
import fileHelper from "@/utils/files";
import { nextTick } from 'vue';
import Modal from "@/components/utils/Modal.vue";
import wordClient from "@/client/word.js";
import progress from "@/progress/progress";
import SkeletonLoader from "vue3-skeleton-loader";

export default {
  props: {
    subLevelId: String,
  },
  components: {
    EditorExView,
    DescView,
    Modal,
    SkeletonLoader,
  },
  emits: ['showModalReg', 'loadLesson'],
  // watch: {
  //   subLevelId: function(newVal, oldVal) {
  //     console.log('Prop subLevelId changed: ', newVal, ' | was: ', oldVal)
  //   }
  // },
  mounted() {
    if (this.subLevelId !== "") {
      subLevelClient.SubLevelGetById(this.subLevelId, data => {
          this.subLevelData = data
          this.subLevelName = data.sub_level.name
          this.parseSubLevelContent()
          this.isLoading = false
          this.onLoadLesson(this.subLevelData)
        }, error => {
          if (error.response && error.response.status === 403) {
            if (this.$store.getters.isUserAuthorized) {
              // window.location.href = "/"
            } else {
              if (document.querySelector("#show-modal-enter")) {
                document.querySelector("#show-modal-enter").click();
              }
            }
          }
        })
    }

    this.$watch(
        () => this.subLevelId,
        (newId, oldId) => {
          subLevelClient.SubLevelGetById(newId, data => {
            this.subLevelData = data
            this.subLevelName = data.sub_level.name
            this.parseSubLevelContent()
            this.isLoading = false
            this.onLoadLesson(this.subLevelData)
          }, error => {
            if (error.response && error.response.status === 403) {
              if (this.$store.getters.isUserAuthorized) {
                // window.location.href = "/"
              } else {
                if (document.querySelector("#show-modal-enter")) {
                  document.querySelector("#show-modal-enter").click();
                }
              }
            }
          })
        }
    )
  },
  data: () => ({
    modalWordContent: "",
    showModalWord: false,
    subLevelData: {},
    exList: new Map(),
    nextLevelLink: '',
    prevLevelLink: '',
    showNextBtn: false,
    showRegBtn: false,
    subLevelName: '',
    isLoading: true,
    levelContent: [
      // {
      //   type: "desc",
      //   text: "## Заголовок\n Тестовое объяснение упражнения\n\n Тестовое объяснение упражнения\n\n Тестовое объяснение упражнения\n\n",
      // },
      // {
      //   type: "translate",
      //   name: "Task Header 1",
      //   tasks: [
      //     {
      //       task: "Я есть (a) друг.",
      //       answer: "I am a friend",
      //       result: false,
      //     },
      //     {
      //       task: "Ты есть (a) доктор.",
      //       answer: "You are a doctor",
      //       result: false,
      //     },
      //     {
      //       task: "Она есть (a) мама.",
      //       answer: "She is a mother",
      //       result: false,
      //     },
      //   ],
      // },
      // {
      //   type: "desc",
      //   text: "## Заголовок 2\n Тестовое объяснение упражнения 2\n\n Тестовое объяснение упражнения\n\n Тестовое объяснение упражнения\n\n",
      // },
    ],
  }),
  methods: {
    onLoadLesson(subLevelData) {
      this.$emit('loadLesson', {
        levelMark: subLevelData.sub_level.level_mark,
        lessonMark: subLevelData.sub_level.sub_level_mark,
        lessonName: subLevelData.sub_level.name,
      })
    },
    getCountOfCompletedExercises() {
      let count = 0
      for (const ex of this.subLevelData.exercises) {
        if (ex.progress_status === 'completed') {
          count++
        }
      }
      return count
    },
    onExCompleted(eventData) {
      let currentExIdx = this.getKeyIndex(this.exList, '{{ex:'+eventData.exId+':}}')

      if (currentExIdx < this.subLevelData.exercises.length-1) {
        let userProgress = progress.GetProgress()
        if (userProgress.ExMainSort == eventData.nextMainSort) {
          this.subLevelData.exercises[currentExIdx+1].progress_status = 'in_progress'
        }
      } else {
        if (eventData.nextLevelMark > progress.MaxAccessLevelUnregister && !this.$store.getters.isUserAuthorized) {
          this.showRegBtn = true
        } else {
          this.showNextBtn = true
        }
      }
    },
    onStartAgain(eventData) {
      let currentExIdx = this.getKeyIndex(this.exList, '{{ex:'+eventData.exId+':}}')

      for (let i in this.levelContent) {
        if (this.levelContent[i].idx == currentExIdx) {
          this.levelContent[i].exKey = this.levelContent[i].exKey + 100
          this.levelContent[i].open = true
        }
      }
    },
    emitShowModalReg() {
      this.$emit('showModalReg')
    },
    prepareExList(matches, exercises, callback) {
      const ids = []

      for (let i in matches) {
        let matchSplit = matches[i].split(':')
        ids.push(matchSplit[1])
      }

      if (ids.length > 0) {
        const exMap = new Map()

        for (let i in exercises) {
          exMap.set(exercises[i].id.toString(), exercises[i])
        }

        for (let i in matches) {
          let matchSplit = matches[i].split(':')
          this.exList.set(matches[i], exMap.get(matchSplit[1]))
        }

        callback()
      } else {
        callback()
      }
    },
    parseSubLevelContent() {
      if (!this.$store.getters.isUserAuthorized) {
        let userProgress = progress.GetProgress()
        for (let i in this.subLevelData.exercises) {
          if (this.subLevelData.exercises[i].main_sort < userProgress.ExMainSort) {
            this.subLevelData.exercises[i].progress_status = 'completed'
          } else if (this.subLevelData.exercises[i].main_sort === userProgress.ExMainSort) {
            this.subLevelData.exercises[i].progress_status = 'in_progress'
          } else {
            this.subLevelData.exercises[i].progress_status = 'forbidden'
          }
        }
      }

      if (this.subLevelData.prev_sub_level_id) {
        this.prevLevelLink = '/sub-levels/' + this.subLevelData.prev_sub_level_id
      }
      if (this.subLevelData.next_sub_level_id) {
        this.nextLevelLink = '/sub-levels/' + this.subLevelData.next_sub_level_id
      }

      let content = this.subLevelData.sub_level.content;
      // const regex = /(.*?)({{.*?}})(.*)/gsd;
      const regex = /(.+?\s)({{.*?}})/gs;

      let m;
      const levelContent = [];
      let lastMatch = ''
      const exMatches = []

      while ((m = regex.exec(content)) !== null) {
        if (m.index === regex.lastIndex) {
          regex.lastIndex++;
        }

        m.forEach((match, groupIndex) => {
          // console.log(`Found match, group ${groupIndex}: ${match}`);

          if (groupIndex === 2) {
            exMatches.push(match);
          }
        });
      }

      this.prepareExList(exMatches, this.subLevelData.exercises, () => {
        while ((m = regex.exec(content)) !== null) {
          // This is necessary to avoid infinite loops with zero-width matches
          if (m.index === regex.lastIndex) {
            regex.lastIndex++;
          }

          m.forEach((match, groupIndex) => {
            // console.log(`Found match, group ${groupIndex}: ${match}`);

            if (groupIndex === 1) {
              levelContent.push(
                  {
                    type: "desc",
                    text: match,
                  }
              );
            }

            lastMatch = match
          });

          m.forEach((match, groupIndex) => {
            // console.log(`Found match, group ${groupIndex}: ${match}`);

            if (groupIndex === 2) {
              let ex = this.exList.get(match)
              // console.log("ex", match, ex)
              // console.log("exList data", this.exList)

              if (ex !== undefined) {
                levelContent.push(
                  {
                    type: "translate",
                    id: ex.id,
                    ex: ex,
                    idx: this.getKeyIndex(this.exList, match),
                    tasks: [],
                    exKey: this.getKeyIndex(this.exList, match),
                    open: false,
                  }
                );
              }
            }
          });
        }

        let endLength = content.lastIndexOf(lastMatch) + lastMatch.length
        if (content.length > endLength+1) {
          levelContent.push(
              {
                type: "desc",
                text: content.substring(endLength),
              }
          );
        }

        if (levelContent.length == 0) {
          levelContent.push(
              {
                type: "desc",
                text: content,
              }
          );
        }

        this.levelContent = levelContent
        nextTick(() => {
          this.addVolumeEvents()
          this.bindWordHandlers()
        });
        
        // console.log("endlength", endLength, content.length)
        // console.log("endlength sub", content.substring(endLength))
        // console.log("this.exList", this.exList)
      })

      if (this.getCountOfCompletedExercises() === this.subLevelData.exercises.length) {
        if (this.subLevelData.next_level_mark > progress.MaxAccessLevelUnregister && localStorage.getItem('authToken') === null) {
          this.showRegBtn = true
        } else {
          this.showNextBtn = true
        }
      }

      if (localStorage.getItem('authToken') === null) {
        let userProgress = progress.GetProgress()

        if (this.subLevelData.sub_level.level_mark === 0 && 
          (this.subLevelData.sub_level.sub_level_mark > userProgress.SubLevelMark || this.subLevelData.sub_level.sub_level_mark === 3)
        ) {
          this.showRegBtn = true
        }
      }
    },
    addListener(selector, callback) {
      const elems = document.querySelectorAll(selector)
      const elemsArray = [...elems];

      elemsArray.forEach((item) => {
        item.addEventListener("click", function (event) {
          event.preventDefault();
          callback(this, event);
        });
      });
    },
    addVolumeEvents() {
      this.addListener('.play_audio_file', (elem, event) => {
        fileHelper.playAudioFile(elem.getAttribute("data-file"));
      })
    },
    closeWord() {
      this.showModalWord = false
    },
    bindWordHandlers() {
      this.addListener('.word-def', (elem, event) => {
        const word = elem.innerHTML

        wordClient.WordGetByWord(word, data => {
          if (data && data.id !== undefined) {
            let translations = ''

            for (let i = 0; i < data.definition_short["possible-translations"].length; i++) {
              translations += " - " + data.definition_short["possible-translations"][i] + "<br/>"
            }

            this.modalWordContent = `<div>
<span class="play_audio_file" data-file="/w/${data.file_uuid}">
<span class="word-def">${data.word}</span> [${data.trans}]</span><br/><br/>
${translations}<br/>
<a href="/words-helper/${data.word}" target="blank">Подробнее</a>
</div>`
            this.showModalWord = true

            nextTick(() => {
              this.addListener('#modal-word .play_audio_file', (elem, event) => {
                fileHelper.playAudioFile(elem.getAttribute("data-file"));
              })
            });
          }
        })
      })
    },
    getKeyIndex(map, targetKey) {
      let index = 0;
      for (let [key] of map.entries()) {
          if (key === targetKey) {
              return index;
          }
          index++;
      }
      return -1;
    },
  },
};
</script>

<style scoped>
  .level-end-btns {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;

    .next-btn-alone {
      margin: 0 auto;
    }

    .next-btn {
      /*display: block;
      min-width: 100px;
      margin: 30px 30px;

      box-shadow: 0 4px 8px rgba(8, 6, 28, .3);
      font-weight: 500;
      border: 1px solid transparent;
      font-size: 1rem;
      line-height: 1.5;
      letter-spacing: 1.28px;
      cursor: pointer;
      transition: all .2s ease;

      background-color: #00B2FF;*/
    }
  }



  .skeleton-lines {
    margin-top: 10px;
  }

  .skeleton-line {
    height: 12px;
    width: 100%;
    background: #b4cdfa;
    border-radius: 3px;
    margin-bottom: 15px;
  }

  .skeleton-line.small {
    width: 60%;
  }

  .skeleton-line {
    background: linear-gradient(-90deg, #b4cdfa 25%, #f0f0f0 50%, #b4cdfa 75%);
    background-size: 400% 100%;
    animation: skeleton-loading 1.2s ease-in-out infinite;
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: 0 0;
    }
  }


</style>
